import ReportAsync from './ReportAsync';
import { ReportAsyncGroup } from './ReportAsync/types';

const Coursables = () => {
  return (
    <div className="w-100 px-3">
      <ReportAsync group={ReportAsyncGroup.Coursables} />
    </div>
  );
};

export default Coursables;
